import { ILoadSearchResults } from '../../schemas/Search/Search.schema';

export class SearchResults {
  private readonly carrierState: ILoadSearchResults = {};
  get searchLoads() {
    return this.carrierState.searchLoads;
  }
}
